<template>

  <el-container class="document">
    <el-header class="header">
      <div class="bg">
        <img class="one" src="../imgs/img_element_one.svg" alt=""/>
        <img class="five" src="../imgs/img_element_five.svg" alt=""/>
        <DocumentHeader title="开放平台公告中心"/>
        <FullSearch style="margin-top: 50px"
                    v-model="keyword"
                    docType="3"
                    @search="getSearchList"/>
      </div>

    </el-header>
    <el-container class="content">
      <el-aside class="menu" width="200px">
        <div class="cate-type">
          平台公告目录
        </div>
        <div class="cate-list" v-if="cateList && cateList.length">
          <div index="0" class="notice-cate" :class="{'is-active': '0' == currentCateId}" @click="handleSelect('0')">
            <p>全部公告</p>
          </div>
          <div :index="cate.id"
               class="notice-cate"
               :class="{'is-active': cate.id == currentCateId}"
               v-for="(cate, index) in cateList"
               @click="handleSelect(cate.id)"
               :key="index">
            <p>{{ cate.name }}</p>
          </div>
        </div>
        <el-empty v-else description="暂无API数据" :image-size="50"></el-empty>
      </el-aside>
      <el-main class="main">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
  import DocumentHeader from '../DocumentHeader'
  import FullSearch from '../FullSearch'
  import apis from '@/api/apis'

  export default {
    name: "document",
    components: {DocumentHeader, FullSearch},
    data() {
      return {
        keyword: '',
        cateList: [],
        currentCateId: '0'
      }
    },
    mounted() {
      const params = this.$route.params
      if(params.noticeCateId){
        this.currentCateId = params.noticeCateId
      }
      this.getNoticeCate()
    },
    methods: {
      getSearchList(){
        this.$router.push({
          name:'search',
          params: {keyword:this.keyword,docType:'3'} //1=文档，2=API，3=公告
        })
      },
      getNoticeCate() {
        apis.notice.noticeCate().then(res => {
          this.cateList = res.data
          if(!this.$route.params.noticeCateId) { // 路由中是否有noticeCateId
            this.$router.push({path: `/notice/${this.currentCateId}`})
          }
        })
      },
      handleSelect(id) {
        this.currentCateId = id
        this.$router.push({path: `/notice/${this.currentCateId}`})
      }
    },
    watch:{
      '$route.path'(value){
        // 在公告子路由的时候，点击头部的平台公告，只有路由刷新，组件不会重新加载，手动重置数据
        if(value === '/notice') {
          this.currentCateId = ''
          this.getNoticeCate()
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .document {
    min-height: 100%;
    background: #FAFAFA;
    .header {
      height: 300px !important;
      background: linear-gradient(180deg, #FFFFFF 0%, #F2F5FA 100%);
      margin-bottom: 16px;
      padding: 47px 0 0;
      position: relative;
      .bg {
        width: 1280px;
        height: 100%;
        margin: 0 auto;
        position: relative;
        img.one {
          width: 120px;
          position: absolute;
          z-index: 9;
          left: 60px;
          bottom: 0px;
        }
        img.five {
          width: 150px;
          position: absolute;
          z-index: 9;
          right: 50px;
          top: 0px;
        }
      }
    }
    .content {
      width: 1280px;
      margin: auto;
      .menu {
        margin-right: 8px;
        background: #fff;
        ::v-deep.el-menu {
          border-right: none;
        }
        .cate-type {
          height: 48px;
          line-height: 48px;
          padding: 0 20px;
          font-size: 14px;
          font-weight: bold;
          color: #1E1E28;
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        }
        .cate-list {
          .notice-cate {
            height: 40px;
            line-height: 40px;
            font-size: 12px;
            font-weight: 500;
            padding: 0px 20px;
            color: rgba(30, 30, 40, 0.78);
            cursor: pointer;

            &:hover {
              background: #FAFAFA;
            }

            &.is-active {
              background: #0B4FFC;
              color: #fff;
            }

          }
        }
      }
      .main {
        background: #fff;
        padding: 24px;
      }
    }
  }

</style>
